<template>
  <div class=" q-link-item  " :style="{ width, height, background: bg }" @click="toLink(item)">
    <slot name="badge"></slot>
    <img :src="item.icon" v-if="item.icon" alt="">
    <div class="intro">

      <div class="title">
        {{ item.title }}
      </div>
      <div class="desc" v-if="item.desc && showDesc">
        {{ item.desc }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    width: {
      type: String,
      default: '2.88rem'
    },
    height: {
      type: String,
      default: '1.82rem'
    },
    iconWidth: {
      type: String,
      default: '0.9rem'
    },
    clickable: {
      type: Boolean,
      default: false
    },
    showDesc: {
      type: Boolean,
      default: false
    },
    bg: {
      type: String,
      default: ''
    }


  },
  methods: {
    toLink (item) {
      if (this.clickable) {
        this.$emit('clickable')
        return
      }
      if (item.origin === 'advisory' || item.advisory) {
        this.toAdvisorys()
      }
      if (item && item.path) {
        this.$router.push(item.path)
      }
    }
  }

}
</script>

<style lang="stylus">
.q-link-item
  display flex
  justify-content center
  align-items center
  color #fff
  margin 0 0.08rem
  img
    margin-bottom 0.05rem
  &.flex-col
    flex-direction column
  &.c2
    background-image linear-gradient(180deg, #e8822e 0%, #ffaa54 100%)
  &.c3
    background-image linear-gradient(-180deg, #505efa 0%, #747ff9 100%)
  &.c4
    background-image linear-gradient(-180deg, #e3464e 0%, #fd767c 100%)
  &.c5
    background-image linear-gradient(180deg, #24ad5d 0%, #1ed96c 100%)
  &.c6
    background-image linear-gradient(-180deg, #8d38d3 0%, #c653f1 100%)
  &.c7
    background-image linear-gradient(-180deg, #e96137 0%, #f88360 100%)
  &.c8
    background-image linear-gradient(180deg, #e8822e 0%, #f49343 100%)
  &.c9
    background-image linear-gradient(180deg, #24ad5d 0%, #1ed96c 100%)
  &.c10
    background-image linear-gradient(-180deg, #505efa 0%, #747ff9 100%)
  &.c11
    background-image linear-gradient(-180deg, #e96137 0%, #f07048 100%)
  &.c12
    background-image linear-gradient(-180deg, #3079ff 0%, #599bff 100%)</style>
